/* eslint-disable react-doctor/only-export-components */
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { DocsArticlePage } from "@/components/docs/docs-article-page";
import {
	DocsCenterLayout,
	DocsCenterSidebar,
	useDocsCenterActiveSlug,
} from "@/components/docs/docs-center-layout";
import {
	getHelpCenterNavSections,
	getHelpCenterPost,
} from "@/lib/docs-content";
import { docsHelpCenterLink } from "@/lib/docs-paths";
import { redirectIfModuleDisabled } from "@/lib/module-guards";
import { seo } from "@/utils/seo";

export const Route = createFileRoute("/_docs/docs/$slug")({
	beforeLoad: () => redirectIfModuleDisabled("docs", "/"),
	head: ({ params: { slug } }) => {
		const post = getHelpCenterPost(slug);

		if (!post) {
			return seo({
				title: "Documentation",
				description: "Help center guides.",
			});
		}

		const date = post.date.toISOString();

		return seo({
			title: post.title,
			description: post.summary,
			type: "Article",
			datePublished: date,
			dateModified: date,
		});
	},
	component: DocsArticleRoute,
});

function DocsArticleRoute() {
	const { slug } = Route.useParams();
	const activeSlug = useDocsCenterActiveSlug("/docs");
	const post = getHelpCenterPost(slug);
	const sections = getHelpCenterNavSections();

	if (!post) {
		return <Navigate to="/docs" replace />;
	}

	return (
		<DocsCenterLayout
			mobileNavTitle="Documentation"
			sidebar={
				<DocsCenterSidebar
					title="Documentation"
					description="Help center guides"
					sections={sections}
					activeSlug={activeSlug ?? slug}
					linkForSlug={docsHelpCenterLink}
				/>
			}
		>
			<DocsArticlePage
				title={post.title}
				summary={post.summary}
				mdxModule={post.mdxModule}
				tableOfContents={post.tableOfContents}
			/>
		</DocsCenterLayout>
	);
}
